import { lazy } from "react";
import i18n from "i18next";
import type { DuelModule } from "../types";
import { CONNECT_FOUR_NS, registerConnectFourTranslations } from "./i18n";

registerConnectFourTranslations(i18n);

/** Four in a row (ADR 0080). Keyed `connect_four`; the name people see comes from i18n. */
export const connectFourModule: DuelModule = {
  key: "connect_four",
  namespace: CONNECT_FOUR_NS,
  Board: lazy(() => import("./Board")),
};
